import React from "react";

const PricingSection = () => {
  return (
    <section className="px-6 py-16  text-center" id="sell">
      {/* Title */}
      <h2 className="text-7xl font-extrabold text-gray-900  tracking-widest underline decoration-yellow-500">
          価格プラン
        </h2>
        <p className="mt-6 text-xl text-gray-700 ">
          お得なプランを選んで、毎日の健康習慣を始めましょう。
        </p>

      <div className="grid md:grid-cols-3 gap-8 mt-12">
        {/* 1-Month Plan */}
        <div className="p-8 bg-white  rounded-xl  border-8    border-yellow-300">
          <img src="https://inyoumarket.com/public/media/webp/2021/04/VitaminC0426_007-xl.webp" alt="1 Month Supply" className="w-full rounded-lg mb-4" />
          <h3 className="text-3xl font-bold text-gray-900 ">1ヶ月プラン</h3>
          <p className="text-xl text-gray-700  mt-2">(One Month Plan)</p>
          <p className="text-4xl font-extrabold text-yellow-600 mt-4">¥4,500</p>
          <button className="mt-6 px-6 py-3 text-lg font-semibold bg-yellow-600 text-white rounded-lg hover:bg-yellow-700">今すぐ購入</button>
        </div>

        {/* 2-Month Plan */}
        <div className="p-8 bg-white  rounded-xl  border-8 border-red-500 relative">
          <span className="absolute top-2 right-2 px-3 py-1 bg-red-600 text-white text-sm rounded-lg">🔥 10% OFF</span>
          <img src="https://inyoumarket.com/public/media/2021/05/VitaminC-0396-xl.jpg" alt="2 Month Supply" className="w-full rounded-lg mb-4 mt-2" />
          <h3 className="text-3xl font-bold text-gray-900 ">2ヶ月プラン</h3>
          <p className="text-xl text-gray-700  mt-2">(Two Month Plan)</p>
          <p className="text-4xl font-extrabold text-red-600 mt-4 line-through">¥9,000</p>
          <p className="text-4xl font-extrabold text-red-700">¥8,100</p>
          <button className="mt-6 px-6 py-3 text-lg font-semibold bg-red-600 text-white rounded-lg hover:bg-red-700">今すぐ購入</button>
        </div>

        {/* 3-Month Plan (Best Deal) */}
        <div className="p-8 bg-white  rounded-xl  border-8 border-yellow-700 relative">
          <span className="absolute top-2 right-2 px-3 py-1 bg-yellow-700 text-white text-sm rounded-lg">🔥 20% OFF - BEST VALUE!</span>
          <img src="https://inyoumarket.com/public/media/2021/04/VitaminC0426_017-xl.jpg" alt="3 Month Supply" className="w-full rounded-lg mb-4 mt-2" />
          <h3 className="text-3xl font-bold text-gray-900 ">3ヶ月プラン</h3>
          <p className="text-xl text-gray-700  mt-2">(Three Month Plan)</p>
          <p className="text-4xl font-extrabold text-yellow-700 mt-4 line-through">¥13,500</p>
          <p className="text-4xl font-extrabold text-yellow-800">¥10,800</p>
          <button className="mt-6 px-6 py-3 text-lg font-semibold bg-yellow-700 text-white rounded-lg hover:bg-yellow-800">今すぐ購入</button>
        </div>
      </div>
      <blockquote className="relative text-center  mx-auto mt-24">
  <div className="relative">
    <p className="text-7xl text-gray-800">
      <em className="relative">
        <svg className="absolute -top-8 -start-8 size-16 text-gray-500 sm:h-24 sm:w-24 " width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M7.39762 10.3C7.39762 11.0733 7.14888 11.7 6.6514 12.18C6.15392 12.6333 5.52552 12.86 4.76621 12.86C3.84979 12.86 3.09047 12.5533 2.48825 11.94C1.91222 11.3266 1.62421 10.4467 1.62421 9.29999C1.62421 8.07332 1.96459 6.87332 2.64535 5.69999C3.35231 4.49999 4.33418 3.55332 5.59098 2.85999L6.4943 4.25999C5.81354 4.73999 5.26369 5.27332 4.84476 5.85999C4.45201 6.44666 4.19017 7.12666 4.05926 7.89999C4.29491 7.79332 4.56983 7.73999 4.88403 7.73999C5.61716 7.73999 6.21938 7.97999 6.69067 8.45999C7.16197 8.93999 7.39762 9.55333 7.39762 10.3ZM14.6242 10.3C14.6242 11.0733 14.3755 11.7 13.878 12.18C13.3805 12.6333 12.7521 12.86 11.9928 12.86C11.0764 12.86 10.3171 12.5533 9.71484 11.94C9.13881 11.3266 8.85079 10.4467 8.85079 9.29999C8.85079 8.07332 9.19117 6.87332 9.87194 5.69999C10.5789 4.49999 11.5608 3.55332 12.8176 2.85999L13.7209 4.25999C13.0401 4.73999 12.4903 5.27332 12.0713 5.85999C11.6786 6.44666 11.4168 7.12666 11.2858 7.89999C11.5215 7.79332 11.7964 7.73999 12.1106 7.73999C12.8437 7.73999 13.446 7.97999 13.9173 8.45999C14.3886 8.93999 14.6242 9.55333 14.6242 10.3Z" fill="currentColor"></path>
        </svg>
        <span className="relative ">    「健康への投資は、未来への贈り物。」</span>
      </em>
    </p>
  </div>
</blockquote>
<div className="mt-16 flex flex-col items-center">
        <h3 className="text-4xl font-extrabold text-gray-900 "> 和のこだわり </h3>
        <p className="mt-4 text-xl text-gray-700  max-w-3xl">
          厳選された日本の有機栄養素を活用し、自然な健康をサポートします。
          健康と長寿のために、伝統と科学を融合させた最高品質のサプリメントをご提供いたします。
        </p>
      </div>
 
    </section>
  );
};

export default PricingSection;
